import React, {Component} from 'react';
import styled from "styled-components"
import callSVG from '../static/img/call.svg'
import emailSVG from '../static/img/email.svg'

export const BasicButton = styled.button`
border-radius: 15px;
text-transform: uppercase;
color: white;
user-select: none;
cursor: pointer;
width: 100%;
height: 3.3rem;
position: relative;
border: none;
outline: none;
font-size: 1.5rem;

img{
position: absolute;
height: 1.8rem;
width: 1.8rem;
top: 50%;
left: 30%;
transform: translate(0, -50%);
}
span{
display: block;
position: absolute;
font-weight: 600;
top: 50%;
left: 43%;
transform: translate(0, -50%);
}
`

const CallButton = styled(BasicButton)`
background: #20B337;
`
const EmailButton = styled(BasicButton)`
background-color: #EEB23D;
img{
left: 15%
}
span{
left: 40%
}
`

export class CallPhoneButton extends Component {
    render() {
        return (
            <CallButton>
                <img src={callSVG} alt="call phone" draggable={false}/>
                <span>hivas</span>
            </CallButton>
        );
    }
}

export class ComposeEmailButton extends Component {
    render() {
        return (
            <EmailButton>
                <img src={emailSVG} alt="send email" draggable={false}/>
                <span>Email</span>

            </EmailButton>
        );
    }
}

